import styled from 'styled-components';

type Props = {
  isDooh?: boolean;
  showLocations: boolean;
};

export const LineItemFormContainerStyled = styled.div`
  background: var(--color-sonata-primary-200, #F2F5FC);
  display: flex;
  flex-direction: column;
  flex: 1;
  row-gap: 16px;
`;

export const LineItemFormStyled = styled.div<Props>`
  display: flex;
  flex-direction: column;
  padding: 16px 32px 40px;
  row-gap: 16px;
  background: var(--color-sonata-primary-200, #F2F5FC);
  
  .titleBar {
    padding: var(--spacing-16) 0;
  }

  .liSettings__subsection {
    scroll-margin-top: 16px;

    &--selected {
      border-radius: 8px; 
      box-shadow: 0 0 0 1px var(--color-sonata-interaction-400);
    }

    .dynamicCreativeOptimization {
      margin-bottom: 0;
    }
  }
    
  .calendarSummary {
    padding-top: 40px;
  }

  .liSettings {

    &__scheduleAndDistribution, &__budgetAndGoals, &__pricingModel {
      margin-top: var(--spacing-16);
    }

    &__selectorBox {
      &--hide {
        display: none;
      }
    }

    &__sectionTitle {
    ${props =>
      props.isDooh
        ? `
      padding: 0 0 24px 0
      `
        : ''};
    }

    &__mainSettingsContainer {
      display: flex;
      flex-direction: column;
      row-gap: 16px;
    }

    &__campaignMarketplaceContainer {
      margin-top: 16px;
    }

    &__schedulingModelBox {
      font-family: ${props => props.theme.fontRegular};
      font-size: ${props => props.theme.fontSizeXS};

      .boxBody__container {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
      .schedulePartingContainer {
        border-radius: 8px;
        background: var(--color-sonata-primary-200);
        width: 100%;
        &__header {
          align-items: center;
        }
      }

    }
      
    &__pricingModelBox {
      height: unset;
    }

    &__settings {
      display: flex;
      flex-direction: column;
      row-gap: 24px;
    }
    
    &__dayParting {
      .customSection {
        &__title {
          color: ${props => props.theme.uiColors.multiFlightSectionTitleColor};
          font-size: ${props => props.theme.fontSizeM};
          margin: 0;
        }

        &__description {
          color: ${props => props.theme.uiColors.multiFlightSectionDescriptionColor};
          font-size: ${props => props.theme.fontSizeS};
          margin: 0;
        }
      }

      .schedulePartingContainer {
        margin-top: 24px;
      }
    }

    &__titleBar {
      padding: var(--spacing-16) 0 0 0;

      &--dooh {
        padding: 0;
      }

      &Section {
        &--dooh {
          padding: 0 0 var(--spacing-16) 0;
        }
      }
    }
    
    &__targeting {
      
      &Container {
        display: flex;
        flex-direction: column;
        gap: 16px;
      }
    }
      
    &__map {
      height: 100%;
      ${props => !props.showLocations && 'display: none;'}
    }

    &__creatives {
      &Container {
        display: flex;
        flex-direction: column;
        row-gap: 16px;
      }
    }
  }
`;
